import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const INFINITY_D =
  'M100,54 C86,26 40,26 40,54 C40,82 86,82 100,54 C114,26 160,26 160,54 C160,82 114,82 100,54 Z';

const NODES: Array<{ letter: string; cx: number; cy: number; delay: string }> = [
  { letter: 'W', cx: 55, cy: 34, delay: '0.3s' },
  { letter: 'I', cx: 55, cy: 74, delay: '0.7s' },
  { letter: 'T', cx: 145, cy: 34, delay: '1.1s' },
  { letter: 'S', cx: 145, cy: 74, delay: '1.5s' },
];

const InfinityPathAnimation: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.4);

  return (
    <div ref={ref} className="relative mx-auto w-full max-w-3xl">
      <svg viewBox="0 0 200 108" className="w-full overflow-visible">
        <defs>
          <linearGradient id="infGradH" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#da239d" />
            <stop offset="50%" stopColor="#683ffa" />
            <stop offset="100%" stopColor="#3f86ff" />
          </linearGradient>
        </defs>

        <path d={INFINITY_D} fill="none" stroke="rgba(255,255,255,.08)" strokeWidth="10" strokeLinecap="round" />

        <path
          d={INFINITY_D}
          fill="none"
          stroke="url(#infGradH)"
          strokeWidth="4"
          strokeLinecap="round"
          pathLength={1}
          style={{
            strokeDasharray: 1,
            strokeDashoffset: isVisible ? 0 : 1,
            transition: 'stroke-dashoffset 1.4s ease-out',
          }}
        />

        {isVisible && (
          <circle r="3.2" fill="#fff">
            <animateMotion dur="5s" repeatCount="indefinite" path={INFINITY_D} />
          </circle>
        )}

        {NODES.map((node) => (
          <g
            key={node.letter}
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'scale(1)' : 'scale(0.6)',
              transformOrigin: `${node.cx}px ${node.cy}px`,
              transition: `opacity 0.4s ease-out ${node.delay}, transform 0.4s ease-out ${node.delay}`,
            }}
          >
            <circle cx={node.cx} cy={node.cy} r="12" fill="#0a1440" stroke="url(#infGradH)" strokeWidth="2" />
            <text
              x={node.cx}
              y={node.cy + 5}
              textAnchor="middle"
              className="font-display"
              fontSize="12"
              fontWeight={800}
              fill="#fff"
            >
              {node.letter}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
};

export default InfinityPathAnimation;
